<template>

<div>

      <app-navigator  @typeChenge="ParsContent = $event" :leftMenu='leftMenu' > </app-navigator>

      <v-container fluid >
    <router-view></router-view>
      </v-container>


</div>

</template>

<script>



export default {

  data () {
    return {
      leftMenu: {
        title: "Процедуры",
        items: [ 
         {name:"Список постов", icon:"mdi-comment-multiple-outline", iconColor:"pink",  content:"posts", selected:true },
         {name:"Бот фильтр", icon:"mdi-filter", iconColor:"blue",  content:"filter", selected:false },
         {name:"Сообщения", icon:"mdi-send", iconColor:"yellow",  content:"msg", selected:false },

         {content:"line"},

         {id:1,name:"Поиск групп", icon:"mdi-account-group", iconColor:"green", content:"parser_groups", selected:false },
         {id:2,name:"Поиск страниц", icon:"mdi-account-search", iconColor:"#273C51", content:"pages_search", selected:true },
         {id:3,name:"Поиск видео", icon:"mdi-file-video",iconColor:"red", content:"pars_video", selected:false },
         {id:4,name:"Парсер обсуждений",icon:"mdi-comment-processing-outline",iconColor:"yellow", content:"pars_topics", selected:false },
         {id:5,name:"Парсер постов",icon:"mdi-comment-multiple-outline",iconColor:"pink", content:"pars_posts", selected:false },
         {id:7,name:"Парсер страниц", icon:"mdi-target", iconColor:"#273C51", content:"parser_pages", selected:false },
         {id:8,name:"Фильтры", icon:"mdi-filter", iconColor:"#18E4FF", content:"filters", selected:false },
         {id:9,name:"Мои процессы",icon:"mdi-content-save", iconColor:"#7218FF", count: "processes",  content:"history", selected:false },
        ]
      }
    }
  },

}
</script>

<style scoped >
  #content {

  }
</style>
